import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Styles from './styles';

class Footer extends React.Component {
  render () {
    const childComponents =  React.Children.toArray(this.props.children);
    const leftAreaComponents = childComponents.filter(component => component.props.slot === 'left');
    const rightAreaComponents = childComponents.filter(component => component.props.slot === 'right');
    const centerAreaComponents = childComponents.filter(component => component.props.slot === 'center' || typeof component.props.slot === 'undefined');

    return (
      <div style={Styles.wrapper}>
        <div style={[Styles.area, Styles.areaLeft]}>{leftAreaComponents}</div>
        <div style={[Styles.area, Styles.center]}>{centerAreaComponents}</div>
        <div style={[Styles.area, Styles.areaRight]}>{rightAreaComponents}</div>
      </div>
    );
  }
}

Footer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
}

Footer.defaultProps = {
  children: [],
}

export default Radium(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/index.js